<template>
  <div class="discount-switch-to-api">
    <div class="separator">
      <div class="line"></div>
      <div class="or">או</div>
      <div class="line"></div>
    </div>
    <div class="text bold">חיבור חשבון משותף ישירות באמצעות אתר דיסקונט.</div>
    <div class="text">החיבור תלוי באישור הבנק ועלול לקחת מספר ימים.</div>
    <riseup-button :variant="'discount-secondary'" :title="'חיבור דרך אתר דיסקונט'" :action="switchToDiscountApi"/>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../Segment';
import SourceFields from '../../../../mixins/SourceFields.vue';
import effects from '../../../../store/utilities/effects';

export default {
  name: 'DiscountSwitchToApiConnection',
  mixins: [SourceFields],
  props: [
    'source',
  ],
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  methods: {
    ...mapActions('credentials', ['deleteCredentials', 'createCredentials', 'setDiscountCredentialsType']),
    async switchToDiscountApi() {
      Segment.trackUserInteraction('NewCredentialsCard_ConnectWithApiClicked');
      const newCredentialsId = await this.createCredentials({ sourceName: this.allSourceFields['discount-api'].sourceName });
      this.deleteCredentials({ credentialsId: this.source.credentialsId });
      this.setDiscountCredentialsType({ credentialsId: newCredentialsId, credentialsType: 'single' });
      await effects.scrollToElement(newCredentialsId);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .discount-switch-to-api {
    font-family: SimplerPro;
    padding: 0 30px;

    .separator {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      color: $riseup_gray_2;
      margin: 25px 0;

      .line {
        height: 1px;
        width: 100%;
        background-color: $riseup_gray_1;
      }

      .or {
        margin: 0 15px;
      }
    }

    .text {
      font-size: 20px;
      margin-bottom: 20px;
    }

    .bold {
      font-weight: bold;
    }

    .riseup-button {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/credentials/credentials-card/discount/DiscountSwitchToApiConnection.vue